export default [
  {
    login: "ermolnik",
    id: 15360278,
    node_id: "MDQ6VXNlcjE1MzYwMjc4",
    avatar_url: "https://avatars.githubusercontent.com/u/15360278?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/ermolnik",
    html_url: "https://github.com/ermolnik",
    followers_url: "https://api.github.com/users/ermolnik/followers",
    following_url:
      "https://api.github.com/users/ermolnik/following{/other_user}",
    gists_url: "https://api.github.com/users/ermolnik/gists{/gist_id}",
    starred_url: "https://api.github.com/users/ermolnik/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/ermolnik/subscriptions",
    organizations_url: "https://api.github.com/users/ermolnik/orgs",
    repos_url: "https://api.github.com/users/ermolnik/repos",
    events_url: "https://api.github.com/users/ermolnik/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/ermolnik/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "xchanmolx",
    id: 16154263,
    node_id: "MDQ6VXNlcjE2MTU0MjYz",
    avatar_url: "https://avatars.githubusercontent.com/u/16154263?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/xchanmolx",
    html_url: "https://github.com/xchanmolx",
    followers_url: "https://api.github.com/users/xchanmolx/followers",
    following_url:
      "https://api.github.com/users/xchanmolx/following{/other_user}",
    gists_url: "https://api.github.com/users/xchanmolx/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/xchanmolx/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/xchanmolx/subscriptions",
    organizations_url: "https://api.github.com/users/xchanmolx/orgs",
    repos_url: "https://api.github.com/users/xchanmolx/repos",
    events_url: "https://api.github.com/users/xchanmolx/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/xchanmolx/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "ashwinkanchana",
    id: 41267321,
    node_id: "MDQ6VXNlcjQxMjY3MzIx",
    avatar_url: "https://avatars.githubusercontent.com/u/41267321?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/ashwinkanchana",
    html_url: "https://github.com/ashwinkanchana",
    followers_url: "https://api.github.com/users/ashwinkanchana/followers",
    following_url:
      "https://api.github.com/users/ashwinkanchana/following{/other_user}",
    gists_url: "https://api.github.com/users/ashwinkanchana/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/ashwinkanchana/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/ashwinkanchana/subscriptions",
    organizations_url: "https://api.github.com/users/ashwinkanchana/orgs",
    repos_url: "https://api.github.com/users/ashwinkanchana/repos",
    events_url: "https://api.github.com/users/ashwinkanchana/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/ashwinkanchana/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "nagarajankola",
    id: 48375639,
    node_id: "MDQ6VXNlcjQ4Mzc1NjM5",
    avatar_url: "https://avatars.githubusercontent.com/u/48375639?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/nagarajankola",
    html_url: "https://github.com/nagarajankola",
    followers_url: "https://api.github.com/users/nagarajankola/followers",
    following_url:
      "https://api.github.com/users/nagarajankola/following{/other_user}",
    gists_url: "https://api.github.com/users/nagarajankola/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/nagarajankola/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/nagarajankola/subscriptions",
    organizations_url: "https://api.github.com/users/nagarajankola/orgs",
    repos_url: "https://api.github.com/users/nagarajankola/repos",
    events_url: "https://api.github.com/users/nagarajankola/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/nagarajankola/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "madannaik",
    id: 48375643,
    node_id: "MDQ6VXNlcjQ4Mzc1NjQz",
    avatar_url: "https://avatars.githubusercontent.com/u/48375643?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/madannaik",
    html_url: "https://github.com/madannaik",
    followers_url: "https://api.github.com/users/madannaik/followers",
    following_url:
      "https://api.github.com/users/madannaik/following{/other_user}",
    gists_url: "https://api.github.com/users/madannaik/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/madannaik/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/madannaik/subscriptions",
    organizations_url: "https://api.github.com/users/madannaik/orgs",
    repos_url: "https://api.github.com/users/madannaik/repos",
    events_url: "https://api.github.com/users/madannaik/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/madannaik/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "iamnyk7",
    id: 48375730,
    node_id: "MDQ6VXNlcjQ4Mzc1NzMw",
    avatar_url: "https://avatars.githubusercontent.com/u/48375730?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/iamnyk7",
    html_url: "https://github.com/iamnyk7",
    followers_url: "https://api.github.com/users/iamnyk7/followers",
    following_url:
      "https://api.github.com/users/iamnyk7/following{/other_user}",
    gists_url: "https://api.github.com/users/iamnyk7/gists{/gist_id}",
    starred_url: "https://api.github.com/users/iamnyk7/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/iamnyk7/subscriptions",
    organizations_url: "https://api.github.com/users/iamnyk7/orgs",
    repos_url: "https://api.github.com/users/iamnyk7/repos",
    events_url: "https://api.github.com/users/iamnyk7/events{/privacy}",
    received_events_url: "https://api.github.com/users/iamnyk7/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "keshavrkaranth",
    id: 48642293,
    node_id: "MDQ6VXNlcjQ4NjQyMjkz",
    avatar_url: "https://avatars.githubusercontent.com/u/48642293?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/keshavrkaranth",
    html_url: "https://github.com/keshavrkaranth",
    followers_url: "https://api.github.com/users/keshavrkaranth/followers",
    following_url:
      "https://api.github.com/users/keshavrkaranth/following{/other_user}",
    gists_url: "https://api.github.com/users/keshavrkaranth/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/keshavrkaranth/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/keshavrkaranth/subscriptions",
    organizations_url: "https://api.github.com/users/keshavrkaranth/orgs",
    repos_url: "https://api.github.com/users/keshavrkaranth/repos",
    events_url: "https://api.github.com/users/keshavrkaranth/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/keshavrkaranth/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "zendy199x",
    id: 50132805,
    node_id: "MDQ6VXNlcjUwMTMyODA1",
    avatar_url: "https://avatars.githubusercontent.com/u/50132805?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/zendy199x",
    html_url: "https://github.com/zendy199x",
    followers_url: "https://api.github.com/users/zendy199x/followers",
    following_url:
      "https://api.github.com/users/zendy199x/following{/other_user}",
    gists_url: "https://api.github.com/users/zendy199x/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/zendy199x/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/zendy199x/subscriptions",
    organizations_url: "https://api.github.com/users/zendy199x/orgs",
    repos_url: "https://api.github.com/users/zendy199x/repos",
    events_url: "https://api.github.com/users/zendy199x/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/zendy199x/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "MIMER17",
    id: 53181663,
    node_id: "MDQ6VXNlcjUzMTgxNjYz",
    avatar_url: "https://avatars.githubusercontent.com/u/53181663?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/MIMER17",
    html_url: "https://github.com/MIMER17",
    followers_url: "https://api.github.com/users/MIMER17/followers",
    following_url:
      "https://api.github.com/users/MIMER17/following{/other_user}",
    gists_url: "https://api.github.com/users/MIMER17/gists{/gist_id}",
    starred_url: "https://api.github.com/users/MIMER17/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/MIMER17/subscriptions",
    organizations_url: "https://api.github.com/users/MIMER17/orgs",
    repos_url: "https://api.github.com/users/MIMER17/repos",
    events_url: "https://api.github.com/users/MIMER17/events{/privacy}",
    received_events_url: "https://api.github.com/users/MIMER17/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "surajpai50612",
    id: 53591334,
    node_id: "MDQ6VXNlcjUzNTkxMzM0",
    avatar_url: "https://avatars.githubusercontent.com/u/53591334?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/surajpai50612",
    html_url: "https://github.com/surajpai50612",
    followers_url: "https://api.github.com/users/surajpai50612/followers",
    following_url:
      "https://api.github.com/users/surajpai50612/following{/other_user}",
    gists_url: "https://api.github.com/users/surajpai50612/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/surajpai50612/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/surajpai50612/subscriptions",
    organizations_url: "https://api.github.com/users/surajpai50612/orgs",
    repos_url: "https://api.github.com/users/surajpai50612/repos",
    events_url: "https://api.github.com/users/surajpai50612/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/surajpai50612/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "llokey-09",
    id: 56479754,
    node_id: "MDQ6VXNlcjU2NDc5NzU0",
    avatar_url: "https://avatars.githubusercontent.com/u/56479754?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/llokey-09",
    html_url: "https://github.com/llokey-09",
    followers_url: "https://api.github.com/users/llokey-09/followers",
    following_url:
      "https://api.github.com/users/llokey-09/following{/other_user}",
    gists_url: "https://api.github.com/users/llokey-09/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/llokey-09/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/llokey-09/subscriptions",
    organizations_url: "https://api.github.com/users/llokey-09/orgs",
    repos_url: "https://api.github.com/users/llokey-09/repos",
    events_url: "https://api.github.com/users/llokey-09/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/llokey-09/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Supreethnayak",
    id: 59947774,
    node_id: "MDQ6VXNlcjU5OTQ3Nzc0",
    avatar_url: "https://avatars.githubusercontent.com/u/59947774?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Supreethnayak",
    html_url: "https://github.com/Supreethnayak",
    followers_url: "https://api.github.com/users/Supreethnayak/followers",
    following_url:
      "https://api.github.com/users/Supreethnayak/following{/other_user}",
    gists_url: "https://api.github.com/users/Supreethnayak/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Supreethnayak/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/Supreethnayak/subscriptions",
    organizations_url: "https://api.github.com/users/Supreethnayak/orgs",
    repos_url: "https://api.github.com/users/Supreethnayak/repos",
    events_url: "https://api.github.com/users/Supreethnayak/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Supreethnayak/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "shreyassp17",
    id: 64488662,
    node_id: "MDQ6VXNlcjY0NDg4NjYy",
    avatar_url: "https://avatars.githubusercontent.com/u/64488662?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/shreyassp17",
    html_url: "https://github.com/shreyassp17",
    followers_url: "https://api.github.com/users/shreyassp17/followers",
    following_url:
      "https://api.github.com/users/shreyassp17/following{/other_user}",
    gists_url: "https://api.github.com/users/shreyassp17/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/shreyassp17/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/shreyassp17/subscriptions",
    organizations_url: "https://api.github.com/users/shreyassp17/orgs",
    repos_url: "https://api.github.com/users/shreyassp17/repos",
    events_url: "https://api.github.com/users/shreyassp17/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/shreyassp17/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "kevkanae",
    id: 64493268,
    node_id: "MDQ6VXNlcjY0NDkzMjY4",
    avatar_url: "https://avatars.githubusercontent.com/u/64493268?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/kevkanae",
    html_url: "https://github.com/kevkanae",
    followers_url: "https://api.github.com/users/kevkanae/followers",
    following_url:
      "https://api.github.com/users/kevkanae/following{/other_user}",
    gists_url: "https://api.github.com/users/kevkanae/gists{/gist_id}",
    starred_url: "https://api.github.com/users/kevkanae/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/kevkanae/subscriptions",
    organizations_url: "https://api.github.com/users/kevkanae/orgs",
    repos_url: "https://api.github.com/users/kevkanae/repos",
    events_url: "https://api.github.com/users/kevkanae/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/kevkanae/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "AishwaryaKudatarkar",
    id: 65335951,
    node_id: "MDQ6VXNlcjY1MzM1OTUx",
    avatar_url: "https://avatars.githubusercontent.com/u/65335951?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/AishwaryaKudatarkar",
    html_url: "https://github.com/AishwaryaKudatarkar",
    followers_url: "https://api.github.com/users/AishwaryaKudatarkar/followers",
    following_url:
      "https://api.github.com/users/AishwaryaKudatarkar/following{/other_user}",
    gists_url:
      "https://api.github.com/users/AishwaryaKudatarkar/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/AishwaryaKudatarkar/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/AishwaryaKudatarkar/subscriptions",
    organizations_url: "https://api.github.com/users/AishwaryaKudatarkar/orgs",
    repos_url: "https://api.github.com/users/AishwaryaKudatarkar/repos",
    events_url:
      "https://api.github.com/users/AishwaryaKudatarkar/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/AishwaryaKudatarkar/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "adishshanbhag",
    id: 69667020,
    node_id: "MDQ6VXNlcjY5NjY3MDIw",
    avatar_url: "https://avatars.githubusercontent.com/u/69667020?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/adishshanbhag",
    html_url: "https://github.com/adishshanbhag",
    followers_url: "https://api.github.com/users/adishshanbhag/followers",
    following_url:
      "https://api.github.com/users/adishshanbhag/following{/other_user}",
    gists_url: "https://api.github.com/users/adishshanbhag/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/adishshanbhag/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/adishshanbhag/subscriptions",
    organizations_url: "https://api.github.com/users/adishshanbhag/orgs",
    repos_url: "https://api.github.com/users/adishshanbhag/repos",
    events_url: "https://api.github.com/users/adishshanbhag/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/adishshanbhag/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "prithshenoy",
    id: 69802402,
    node_id: "MDQ6VXNlcjY5ODAyNDAy",
    avatar_url: "https://avatars.githubusercontent.com/u/69802402?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/prithshenoy",
    html_url: "https://github.com/prithshenoy",
    followers_url: "https://api.github.com/users/prithshenoy/followers",
    following_url:
      "https://api.github.com/users/prithshenoy/following{/other_user}",
    gists_url: "https://api.github.com/users/prithshenoy/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/prithshenoy/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/prithshenoy/subscriptions",
    organizations_url: "https://api.github.com/users/prithshenoy/orgs",
    repos_url: "https://api.github.com/users/prithshenoy/repos",
    events_url: "https://api.github.com/users/prithshenoy/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/prithshenoy/received_events",
    type: "User",
    site_admin: false,
  },
];
